import internal_brand_1_landscape from './internal/brand_1/landscape.json';
import internal_brand_1_square from './internal/brand_1/square.json';
import internal_brand_1_vertical from './internal/brand_1/vertical.json';
import internal_brand_1_fourfive from './internal/brand_1/fourfive.json';
import partials_attribution_landscape from './partials/attribution/landscape.json';
import partials_attribution_square from './partials/attribution/square.json';
import partials_attribution_vertical from './partials/attribution/vertical.json';
import partials_attribution_fourfive from './partials/attribution/fourfive.json';

export const partialSceneDesigns = {
    internal: {
        'internal:brand_1': {
            landscape: internal_brand_1_landscape,
            square: internal_brand_1_square,
            vertical: internal_brand_1_vertical,
            fourfive: internal_brand_1_fourfive,
        },
    },

    partials: {
        'partials:attribution': {
            landscape: partials_attribution_landscape,
            square: partials_attribution_square,
            vertical: partials_attribution_vertical,
            fourfive: partials_attribution_fourfive,
        },
    },
};
